import { render, staticRenderFns } from "./InsectTypeSnippets.vue?vue&type=template&id=00d41370&scoped=true&"
import script from "./InsectTypeSnippets.vue?vue&type=script&lang=js&"
export * from "./InsectTypeSnippets.vue?vue&type=script&lang=js&"
import style0 from "./InsectTypeSnippets.vue?vue&type=style&index=0&id=00d41370&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d41370",
  null
  
)

/* custom blocks */
import block0 from "./InsectTypeSnippets.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d41370')) {
      api.createRecord('00d41370', component.options)
    } else {
      api.reload('00d41370', component.options)
    }
    module.hot.accept("./InsectTypeSnippets.vue?vue&type=template&id=00d41370&scoped=true&", function () {
      api.rerender('00d41370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/Top5InsectsPanel/InsectTypeSnippets.vue"
export default component.exports